import React from 'react';
import { ImageIcon } from 'lucide-react';
interface ImagePlaceholderProps {
  label: string;
  className?: string;
}
export function ImagePlaceholder({
  label,
  className = ''
}: ImagePlaceholderProps) {
  return <div className={`flex flex-col items-center justify-center bg-esbelta-lavender border-2 border-dashed border-esbelta-violet/40 rounded-lg p-4 text-center ${className}`} aria-label={`Espacio para imagen: ${label}`} role="img" data-id="element-169">
      <ImageIcon className="w-8 h-8 text-esbelta-violet/60 mb-2" data-id="element-170" />
      <span className="text-sm font-medium text-esbelta-violet/80" data-id="element-171">
        {label}
      </span>
    </div>;
}